module.exports = __webpack_public_path__ + "static/media/002_Bitmap.01a8aa4b.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/screenshots/mashery/002_Bitmap.png
// module id = 548
// module chunks = 0